import {
    ADD_USER,
    GET_USER,
    SET_USER,
    LOGOUT
} from "../actions/types";

const initialState = null;

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_USER:
            return { ...action.payload };
        case GET_USER:
            return {
                ...state,
                ...action.payload
            };
        case SET_USER:
            return {
                ...action.payload
            };

        case LOGOUT:
            return null;

        default:
            return state;
    }
};

export default userReducer;
